import {
  Abha,
  Appointment,
  MedicalHistory,
  MedicalHistoryConfig,
} from "@elixir/types";
import {
  TReceiptSource,
  TRequestPaymentSource,
} from "../stores/receipt-store/types";

export const BILLING_POPUP_ID = "BILLING_POPUP_ID";
export const ELIXIR_POPUP_MOUNT = "ELIXIR_POPUP_MOUNT";
export const QUESTIONNAIRE_CONTAINER_ID = "divShowQuestionnaireList";

export const EKA_EVENT = "eka-event";

export enum EVENT_TYPES {
  BILLING_POPUP = "BILLING_POPUP",
  CLOSE_BILLING_POPUP = "CLOSE_BILLING_POPUP",
  DESTROY_CONTAINER = "DESTROY_CONTAINER",
  DR_SWITCH_EVENT = "DR_SWITCH_EVENT",
  REQUEST_PAYMENT = "REQUEST_PAYMENT",
  ADD_NEW_PT_APPT = "ADD_NEW_PT_APPT",
  OPEN_TRIAL_PERSUASION_POPUP = "OPEN_TRIAL_PERSUASION_POPUP",
  SHOW_TRIAL_PERSUASION_BANNER = "SHOW_TRIAL_PERSUASION_BANNER",
  HPR_HFR_ONBOARDING = "HPR_HFR_ONBOARDING",
  CLOSE_HPR_HFR_ONBOARDING = "CLOSE_HPR_HFR_ONBOARDING",
  ADD_MH_QUEUE = "ADD_MH_QUEUE",
  CLOSE_MH_POPUP = "CLOSE_MH_POP",
  HPR_HFR_ONBOARDING_AADHAR_PRESENT = "HPR_HFR_ONBOARDING_AADHAR_PRESENT",

  /**
   * dispatchEvent(new CustomEvent("eka-event",{detail: {type: "SHOW_QUESTIONNAIRE_LIST"}}))
   */
  SHOW_QUESTIONNAIRE_LIST = "SHOW_QUESTIONNAIRE_LIST",
  CLOSE_QUESTIONNAIRE_LIST = "CLOSE_QUESTIONNAIRE_LIST",
}

export interface DestroyContainerEvent {
  type: EVENT_TYPES.DESTROY_CONTAINER;
  containerId: string;
}

export type BillingPopupData = {
  aid: string | null;
  docid?: string;
  patient: Appointment["patient"];
  uhid: string | null;
  clinicId: string;
  source: TReceiptSource;
  createNewAppt?: boolean;
  aptDate?: string;
  serviceInfo?: {
    id: number;
    name: string;
    price: number;
  };
  appointment?: Appointment;
};

type RequestPaymentData = {
  aid: string | null;
  docid?: string;
  patient: Appointment["patient"];
  uhid: string | null;
  clinicId: string;
  source: TRequestPaymentSource;
  createNewAppt?: boolean;
  aptDate?: string;
  serviceInfo?: {
    id: number;
    name: string;
    price: number;
  };
  appointment?: Appointment;
};

export type PatientEventData = {
  id?: string;
  localId: string;
  personal: {
    name: {
      f: string;
      l?: string;
    };
    phone?: {
      c: string;
      n: string;
    };
    age?: {
      dob?: string;
      value?: string; // age in yrs
      month?: string;
    };
    gender: string;
    onApp?: boolean;
    "health-ids"?: string[];
  };
  createdAt?: Date;
  updatedAt?: Date;
  lastVisitedAt?: Date;
  followUpDate?: Date;
  medical?: MedicalHistory;
  lastGoingVisit?: string;
  bloodgroup?: string;
  formData?: {
    label: string;
    type: "number" | "string" | "select";
    key: string;
    value: string | number;
  }[];
  archived?: boolean;
  link?: string[];
  abha?: Abha;
};

export type PresentAadhaarData = {
  aadhaar: string;
};

export interface BillingPopupEvent {
  type: EVENT_TYPES.BILLING_POPUP;
  data: BillingPopupData;
}

export interface RequestPaymentEvent {
  type: EVENT_TYPES.REQUEST_PAYMENT;
  data: RequestPaymentData;
}

export interface CloseBillingPopupEvent {
  type: EVENT_TYPES.CLOSE_BILLING_POPUP;
}

export interface DrSwitchEvent {
  type: EVENT_TYPES.DR_SWITCH_EVENT;
}

export interface AddPatientEvent {
  type: EVENT_TYPES.ADD_NEW_PT_APPT;
  data?: PatientEventData;
}
export interface OpenTrialPersuasionPopup {
  type: EVENT_TYPES.OPEN_TRIAL_PERSUASION_POPUP;
}

export interface ShowTrialPersuasionBanner {
  type: EVENT_TYPES.SHOW_TRIAL_PERSUASION_BANNER;
}

export interface OpenHprHfrOnboarding {
  type: EVENT_TYPES.HPR_HFR_ONBOARDING;
}

export interface CloseHprHfrOnboarding {
  type: EVENT_TYPES.CLOSE_HPR_HFR_ONBOARDING;
}

export interface AddMhQueue {
  type: EVENT_TYPES.ADD_MH_QUEUE;
  data: MedicalHistoryConfig;
}

export interface CloseMhQueue {
  type: EVENT_TYPES.CLOSE_MH_POPUP;
}

export interface OpenHprHfrOnboardingWithAadharPresent {
  type: EVENT_TYPES.HPR_HFR_ONBOARDING_AADHAR_PRESENT;
  data: PresentAadhaarData;
}

export interface OpenSaQuestionnaireListEvent {
  type: EVENT_TYPES.SHOW_QUESTIONNAIRE_LIST;
  data: {
    apt: Appointment;
  };
}

export interface CloseSaQuestionnaireListEvent {
  type: EVENT_TYPES.CLOSE_QUESTIONNAIRE_LIST;
}

export type IncomingEvents =
  | DestroyContainerEvent
  | BillingPopupEvent
  | CloseBillingPopupEvent
  | DrSwitchEvent
  | RequestPaymentEvent
  | AddPatientEvent
  | OpenTrialPersuasionPopup
  | ShowTrialPersuasionBanner
  | OpenHprHfrOnboarding
  | CloseHprHfrOnboarding
  | AddMhQueue
  | CloseMhQueue
  | OpenHprHfrOnboardingWithAadharPresent
  | OpenSaQuestionnaireListEvent
  | CloseSaQuestionnaireListEvent;
